import { ResourceConfig } from '@hidat/huijs-resource';
import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  MediaRepositoryInterface,
  nNumber,
  nString,
  uString,
  Uuid,
} from '@hidat/huijs-common';
import { SplixerResourceInterface } from './splixer-resource.interface';
import {
  splixerFieldConfigs,
  splixerSystemFields,
} from './splixer-fields.const';
import { FileSystemStorageConfig, S3StorageConfig } from '@hidat/huijs-media';

export const RepositoryConfig = new ResourceConfig(
  'Repository',
  'repositories',
  true,
  true,
)
  .addFields(splixerSystemFields)
  .addFields([
    splixerFieldConfigs.name.setRequired(true),
    new FieldConfig('storageKlass'),
    new FieldConfig('namingKlass'),
    new FieldConfig('storageAttributes', FieldDataTypes.HASH),
    new FieldConfig('namingAttributes', FieldDataTypes.HASH),
    new FieldConfig('supportsPermalinks', FieldDataTypes.BOOLEAN),
  ])
  .setSorts({
    name: 'name',
  });

/**
 * Repository
 * Defines a way to access media files
 */
export interface RepositoryInterface
  extends SplixerResourceInterface<Uuid>, MediaRepositoryInterface {
  tenantId: Uuid | undefined;
  name: uString;
  storageKlass: uString;
  storageAttributes: AnyHash | undefined;
  namingKlass: uString;
  namingAttributes: AnyHash | undefined;
  supportsPermalinks: boolean | undefined;
}

//@TODO: These should pull from @hidat/media.....
export interface RepositoryS3Settings extends S3StorageConfig {
  profile: uString;
  region: uString;
  bucketName: uString;
  rootPath: nString;
  secureUrlSeconds: nNumber;
  distributionUrl: nString; // Cloudfront distribution URL
}

export const RepositoryS3SettingsFieldConfigs = [
  new FieldConfig('profile').setRequired(true),
  new FieldConfig('region').setRequired(true),
  new FieldConfig('bucketName').setRequired(true),
  new FieldConfig('rootPath'),
  new FieldConfig('distributionUrl'),
  new FieldConfig('secureUrlSeconds'),
];

export interface RepositoryFsSettings extends FileSystemStorageConfig {
  rootPath: nString;
  serverPath: nString;
  serverUrl: uString;
}

export const RepositoryFsSettingsFieldConfigs = [
  new FieldConfig('rootPath').setRequired(true),
  new FieldConfig('serverPath'),
  new FieldConfig('serverUrl'),
];
